import React from 'react';
import classes from './Spinner.module.css';

const Spinner = () => {
    return (
        <div className={classes.spin}>
            <span role='img' aria-label='spin'>🚦</span>
        </div>
    );
};

export default Spinner;
